export const RESTO365_FRANCHISE = 'RESTO365_FRANCHISE'

export const RESTO365_FRANCHISE_CREATE = `${RESTO365_FRANCHISE}/createFranchiseReview`

export const RESTO365_ALL_FRANCHISE_LIST = `${RESTO365_FRANCHISE}/getFranchises`

export const RESTO365_ALL_FRANCHISE_CONTACT_LIST = `${RESTO365_FRANCHISE}/getFranchiseContact`

export const RESTO365_GET_FRANCHISE_BY_ID = `${RESTO365_FRANCHISE}/getFranchiseById`

export const RESTO365_GET_FRANCHISE_CONTACT_BY_ID = `${RESTO365_FRANCHISE}/getFranchiseContactById`

export const RESTO365_GET_FRANCHISE_REVIEWS = `${RESTO365_FRANCHISE}/getFranchiseReviews`

export const RESTO365_GET_FRANCHISE_REVIEWS_BY_ID = `${RESTO365_FRANCHISE}/getFranchiseReviewsById`

export const RESTO365_CREATE_FRANCHISE_REVIEW = `${RESTO365_FRANCHISE}/createFranchiseReview`

export const RESTO365_UPDATE_FRANCHISE_REVIEW = `${RESTO365_FRANCHISE}/updateFranchiseReview`

export const RESTO365_FRANCHISE_ERROR_RESET = `${RESTO365_FRANCHISE}/errorReset`

export const RESTO365_FRANCHISE_COMMON_SEARCH = `${RESTO365_FRANCHISE}/commonSearchInitialData`

export const RESTO365_CREATE_FRANCHISE = `${RESTO365_FRANCHISE}/createFranchise`

export const RESTO365_GET_FRANCHISE_CONTACTS_BY_FRANCHISE_ID = `${RESTO365_FRANCHISE}/getFranchiseContactsByFranchiseId`

export const RESTO365_CREATE_FRANCHISE_CONTACT = `${RESTO365_FRANCHISE}/createFranchiseContact`

export const RESTO365_UPDATE_FRANCHISE_CONTACT = `${RESTO365_FRANCHISE}/updateFranchiseContact`

export const RESTO365_CHANGE_PRIMARY_FRANCHISE_CONTACT = `${RESTO365_FRANCHISE}/changePrimaryFranchiseContact`

export const RESTO365_CHECK_FRANCHISE_CONTACT_EMAIL = `${RESTO365_FRANCHISE}/checkFranchiseContactEmail`

export const RESTO365_GET_FRANCHISE_REVIEW_DATA_BY_POS_STORE_ID = `${RESTO365_FRANCHISE}/getFranchiseReviewDataByPosStoreId`

export const RESTO365_GET_FRANCHISE_REVIEW_QUESTIONS_BY_SECTION = `${RESTO365_FRANCHISE}/getFranchiseReviewQuestionsBySection`

export const RESTO365_CREATE_FRANCHISE_REVIEW_SECTION_RATINGS = `${RESTO365_FRANCHISE}/createFranchiseReviewSectionRatings`

export const RESTO365_GET_FRANCHISE_REVIEW_SECTION_RATINGS = `${RESTO365_FRANCHISE}/getFranchiseReviewSectionRatings`

export const RESTO365_GET_FRANCHISE_REVIEW_SECTION_RATING_BY_IDS = `${RESTO365_FRANCHISE}/getFranchiseReviewSectionRatingByIds`

export const RESTO365_UPDATE_FRANCHISE_REVIEW_SECTION_RATING = `${RESTO365_FRANCHISE}/updateFranchiseReviewSectionRating`

export const RESTO365_SEARCH_FRANCHISES = `${RESTO365_FRANCHISE}/searchFranchises`

export const RESTO365_GET_FRANCHISES_BY_IDS = `${RESTO365_FRANCHISE}/getFranchisesByIds`

export const RESTO365_IMPORT_FRANCHISE_REVIEW_DATA = `${RESTO365_FRANCHISE}/importFranchiseReviewData`
